<template>
  <div id="variety-detail">
    <v-container grid-list-xl v-if="varietyDetails">
      <!-- product header -->
      <base-product-header></base-product-header>

      <v-layout align-center justify-center row wrap>
        <!-- detail -->
        <v-flex sm6 xs11>
          <div class="display-1 font-weight-bold">{{ fullname }}</div>
          <div
            class="mt-2 subheading text-uppercase grey--text"
          >{{ varietyDetails.varietynameeng || '' }}</div>
        </v-flex>
      </v-layout>

      <!-- images -->
      <v-layout align-center justify-center row wrap>
        <v-flex my-2 pl-0 sm6 v-if="varietyImages.length" xs12>
          <v-layout row wrap>
            <v-flex
              d-flex
              :key="varietyImage.pictureurl"
              pa-0
              v-for="varietyImage in varietyImages.slice(0, 1)"
              xs7
            >
              <v-img
                :aspect-ratio="4 / 4"
                class="grey lighten-2"
                cover
                :lazy-src="require('@/assets/NoPicture.png')"
                :src="
                  varietyImage.pictureurl
                    ? varietyImage.pictureurl
                    : require('@/assets/NoPicture.png')
                "
              >
                <template v-slot:placeholder>
                  <v-layout align-center fill-height justify-center ma-0>
                    <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>
            </v-flex>
            <v-flex d-flex pa-0 xs4>
              <v-layout row wrap>
                <v-flex
                  d-flex
                  :key="varietyImage.pictureurl"
                  pb-0
                  v-for="varietyImage in varietyImages.slice(1, 2)"
                  xs12
                >
                  <v-img
                    :aspect-ratio="4 / 4"
                    class="grey lighten-2"
                    cover
                    :lazy-src="require('@/assets/NoPicture.png')"
                    :src="
                      varietyImage.pictureurl
                        ? varietyImage.pictureurl
                        : require('@/assets/NoPicture.png')
                    "
                  >
                    <template v-slot:placeholder>
                      <v-layout align-center fill-height justify-center ma-0>
                        <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </v-flex>
                <v-flex
                  d-flex
                  :key="varietyImage.pictureurl"
                  pt-0
                  v-for="varietyImage in varietyImages.slice(2, 3)"
                  xs12
                >
                  <v-img
                    :aspect-ratio="4 / 4"
                    class="grey lighten-2"
                    cover
                    :lazy-src="require('@/assets/NoPicture.png')"
                    :src="
                      varietyImage.pictureurl
                        ? varietyImage.pictureurl
                        : require('@/assets/NoPicture.png')
                    "
                  >
                    <template v-slot:placeholder>
                      <v-layout align-center fill-height justify-center ma-0>
                        <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- description -->
      <v-layout align-center justify-center row wrap>
        <v-flex sm6 xs11>
          <div class="font-THSarabunNew">{{ varietyDetails.varietydescription || 'ไม่มีคำอธิบาย' }}</div>
        </v-flex>
      </v-layout>

      <!-- Content -->
      <v-layout align-center justify-center row wrap>
        <v-flex :key="productContent.idx" sm6 v-for="productContent in productContents" xs11>
          <!-- <div class="title font-THSarabunNew my-4">{{ productContent.title }}</div> -->
          <div class="font-THSarabunNew mb-4" v-html="productContent.content"></div>
        </v-flex>
      </v-layout>

      <!-- Variety Workflow -->
      <WorkflowVarietyBox />

      <v-layout align-center justify-center row wrap>
        <v-flex mt-4 pb-0 xs12>
          <VarietyBox>{{ `${varietyDetails.productname}สายพันธ์ุอื่นๆ` }}</VarietyBox>
        </v-flex>
      </v-layout>

      <!-- Content Searchbox -->
      <v-layout align-center justify-center row wrap>
        <v-flex text-xs-center xs11>
          <base-search-bottom-page></base-search-bottom-page>
        </v-flex>
      </v-layout>

      <!-- Banners -->
      <v-layout align-center justify-center row wrap>
        <v-flex sm6 text-xs-center xs11>
          <base-banners bannerPositionId="BANNERPOS0000004" pageId="PAGES0000005"></base-banners>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
const WorkflowVarietyBox = () => import('@/components/product_search/WorkflowVarietyBox')
import VarietyBox from '@/components/product_search/VarietyBox'
export default {
  name: 'variety-detail',
  components: {
    VarietyBox,
    WorkflowVarietyBox
  },
  data() {
    return {
      productContents: []
    }
  },
  computed: {
    fullname() {
      return `พันธุ์${this.varietyDetails.varietyname}`
    },
    varietyId() {
      return window.atob(this.$route.params.varietyId)
    },
    productId() {
      return window.atob(this.$route.params.productId)
    },
    varietyDetails() {
      return this.$store.getters['Variety/getVarietyDetails'].filter(
        item => item.varietyid == this.varietyId
      )[0]
    },
    varietyImages() {
      return this.$store.getters['Variety/getImages']
    }
  },
  async created() {
    this.$store.dispatch('Variety/fetchVarietyDetails', this.productId)
    await this.$store.dispatch('Variety/fetchImages', this.varietyId)
    this.fetchProductContent()
  },
  methods: {
    async fetchProductContent() {
      try {
        const response = await this.axios.get(
          `portal/product_content/${this.productId}/${this.varietyId}`
        )
        this.productContents = response.data
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss">
#variety-detail {
  img {
    width: 100%;
    height: 100%;
    margin-bottom: 0px;
  }
}
</style>
